import moment from 'moment-timezone';

// Shared by DeliveryDialog.vue and PickupDeliveryEditDialog.vue -- both are "confirm the
// order type switch" dialogs for a group order host, and both need to commit orderType +
// deliveryAddress + scheduledTime to the group-order backend in a single mutation call.
// Previously each dialog hand-rolled its own version of this, which is how they drifted:
// one sent order type + schedule in two separate calls, the other dropped the schedule
// entirely. There is exactly one way group order order-type switches should be committed.

// dayId/timeId are the raw ids the schedule <v-select> options use, NOT a ready ISO string.
// Returns null for ASAP ('now' or unset), otherwise a store-timezone-aware ISO string.
export function buildScheduledTimeISO(dayId, timeId, storeTimezone) {
  if (!timeId || timeId === 'now') return null;
  var dayD = new Date(dayId);
  var timeD = new Date(timeId);
  return moment.tz({
    year: dayD.getFullYear(), month: dayD.getMonth(), date: dayD.getDate(),
    hour: timeD.getHours(), minute: timeD.getMinutes(), second: 0,
  }, storeTimezone || 'America/Toronto').toISOString();
}

// App.vue has a global watcher on checkoutInfo.scheduledTime that independently re-sends
// groupOrder/updateScheduledTime for ANY change to that value. DeliveryDialog.vue writes
// directly to checkoutInfo as the user interacts with it (v-model on the day/time selects,
// the ASAP default set the instant the dialog opens) with no local draft-staging -- so
// every one of those interactions was tripping the watcher and sending a mutation before
// the user ever clicked "Update". This is a held suppression (not one-shot): armed for the
// whole time DeliveryDialog is open mid-switch, released once closeDialog() actually
// resolves (success or failure) -- so nothing reaches the backend until the real commit.
var scheduledTimeWatcherSuppressed = false;
export function holdScheduledTimeWatcherSuppression() {
  scheduledTimeWatcherSuppressed = true;
}
export function releaseScheduledTimeWatcherSuppression() {
  scheduledTimeWatcherSuppressed = false;
}
export function isScheduledTimeWatcherSuppressed() {
  return scheduledTimeWatcherSuppressed;
}

// Commits an order type switch (host only) to the group-order backend in one mutation call:
// SET_ORDER_TYPE, SET_DELIVERY_ADDRESS (DELIVERY only), and SET_SCHEDULED_TIME together.
// No-ops for regular (non-group) orders or non-host participants.
export function commitGroupOrderTypeSwitch($store, { orderType, dayId, timeId }) {
  if (!$store.state.groupOrder.isHost) return Promise.resolve();
  if (!$store.getters['groupOrder/isInGroupOrder']) return Promise.resolve();
  if (!$store.state.groupOrder.group) return Promise.resolve();

  var deliveryAddress = orderType === 'DELIVERY'
    ? ($store.state.cart.deliveryAddress || null)
    : null;
  var storeTimezone = $store.getters.getStore && $store.getters.getStore.timeZone;
  var scheduledTime = buildScheduledTimeISO(dayId, timeId, storeTimezone);

  return $store.dispatch('groupOrder/updateOrderType', {
    orderType: orderType,
    deliveryAddress: deliveryAddress,
    scheduledTime: scheduledTime,
  });
}
